import { render, staticRenderFns } from "./TaskStatusName.vue?vue&type=template&id=b93ab6f2&scoped=true&"
import script from "./TaskStatusName.vue?vue&type=script&lang=js&"
export * from "./TaskStatusName.vue?vue&type=script&lang=js&"
import style0 from "./TaskStatusName.vue?vue&type=style&index=0&id=b93ab6f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b93ab6f2",
  null
  
)

export default component.exports